import React from 'react';
import PropTypes from 'prop-types';
import tw from 'twin.macro';
import TwAutocomplete from '../TwAutocomplete';
import useStyles from './styles';

const SearchAutocomplete = ({
  onChange,
  placeholderText,
  options,
  onInputChange,
  values,
  popperMinWidth,
  onBlur,
  onFocus,
  variant,
  autoFocus,
  freeSolo,
  isLoading,
  disableClearable,
  isMultiple,
  doUseThemeBackground,
  disabled,
  hidePopperWhenEmpty,
  autoComplete,
  getOptionSelected,
}) => {
  const minWidth = popperMinWidth ? `${popperMinWidth}px` : 'initial';
  const variants =
    typeof (variant === undefined ? [] : variant) === 'number' ? [variant] : variant || [];
  const classes = useStyles({
    minWidth,
    noRightBorder:
      variants.indexOf(SearchAutocomplete.Variants.outlineNoRightRadius) > -1 ||
      variants.indexOf(SearchAutocomplete.Variants.outlineNoRadius) > -1,
    noLeftBorder:
      variants.indexOf(SearchAutocomplete.Variants.outlineNoLeftRadius) > -1 ||
      variants.indexOf(SearchAutocomplete.Variants.outlineNoRadius) > -1,
    noBorderWidth: variants.indexOf(SearchAutocomplete.Variants.outlineNoBorderWidth) > -1,
    inputBgColor: disabled
      ? { backgroundColor: '#ddd' }
      : (!!doUseThemeBackground && tw`bg-searchInput-0`) || tw`bg-white`,
  });

  return (
    <TwAutocomplete
      isMultiple={isMultiple}
      placeholderText={placeholderText}
      onChange={onChange}
      classes={classes}
      options={options}
      onInputChange={onInputChange}
      values={values}
      onBlur={onBlur}
      disabled={disabled}
      onFocus={onFocus}
      isNested
      autoFocus={autoFocus}
      freeSolo={freeSolo}
      isLoading={isLoading}
      disableClearable={disableClearable}
      hidePopperWhenEmpty={hidePopperWhenEmpty}
      autoComplete={autoComplete}
      getOptionSelected={getOptionSelected}
    />
  );
};

SearchAutocomplete.Variants = {
  outlineNoRightRadius: 0,
  outlineNoLeftRadius: 1,
  outlineNoRadius: 2,
  outlineNoBorderWidth: 3,
};

SearchAutocomplete.defaultProps = {
  values: null,
  options: undefined,
  popperMinWidth: undefined,
  onBlur: () => {},
  onFocus: () => {},
  variant: undefined,
  autoFocus: undefined,
  disabled: undefined,
  freeSolo: undefined,
  onInputChange: undefined,
  isLoading: undefined,
  disableClearable: undefined,
  isMultiple: false,
  doUseThemeBackground: false,
  hidePopperWhenEmpty: false,
  autoComplete: undefined,
  getOptionSelected: undefined,
};

SearchAutocomplete.propTypes = {
  onChange: PropTypes.func.isRequired,
  onInputChange: PropTypes.func,
  placeholderText: PropTypes.string.isRequired,
  values: PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  }),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      suggests: PropTypes.arrayOf(
        PropTypes.shape({
          value: PropTypes.string,
          label: PropTypes.string,
        }),
      ),
      value: PropTypes.string,
      label: PropTypes.string,
    }),
  ),
  popperMinWidth: PropTypes.number,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  variant: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.number)]),
  autoFocus: PropTypes.bool,
  disabled: PropTypes.bool,
  freeSolo: PropTypes.bool,
  isLoading: PropTypes.bool,
  disableClearable: PropTypes.bool,
  isMultiple: PropTypes.bool,
  doUseThemeBackground: PropTypes.bool,
  hidePopperWhenEmpty: PropTypes.bool,
  autoComplete: PropTypes.string,
  getOptionSelected: PropTypes.func,
};

export default SearchAutocomplete;
